import { useEffect, useRef } from "react";
import DOMPurify from "dompurify";
import { Bold, Italic, List, ListOrdered, Underline, Heading2 } from "lucide-react";

/**
 * Lightweight contentEditable rich text editor with sanitised HTML output.
 * value: HTML string. onChange(html).
 */
const SANITIZE_OPTS = {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "u", "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "span"],
    ALLOWED_ATTR: [],
};

const sanitize = (html) => DOMPurify.sanitize(html || "", SANITIZE_OPTS);

export default function RichTextEditor({ value, onChange }) {
    const ref = useRef(null);

    useEffect(() => {
        const safe = sanitize(value);
        if (ref.current && ref.current.innerHTML !== safe) {
            ref.current.innerHTML = safe;
        }
    }, [value]);

    const exec = (cmd, arg = null) => {
        document.execCommand(cmd, false, arg);
        if (ref.current) onChange(sanitize(ref.current.innerHTML));
    };

    const handleInput = () => {
        if (ref.current) onChange(sanitize(ref.current.innerHTML));
    };

    return (
        <div data-testid="rich-text-editor">
            <div className="rte-toolbar">
                <button type="button" onClick={() => exec("bold")} title="Negrita"><Bold className="w-3 h-3 inline" /></button>
                <button type="button" onClick={() => exec("italic")} title="Cursiva"><Italic className="w-3 h-3 inline" /></button>
                <button type="button" onClick={() => exec("underline")} title="Subrayado"><Underline className="w-3 h-3 inline" /></button>
                <button type="button" onClick={() => exec("formatBlock", "<h3>")} title="Encabezado"><Heading2 className="w-3 h-3 inline" /></button>
                <button type="button" onClick={() => exec("insertUnorderedList")} title="Lista"><List className="w-3 h-3 inline" /></button>
                <button type="button" onClick={() => exec("insertOrderedList")} title="Lista numerada"><ListOrdered className="w-3 h-3 inline" /></button>
                <button type="button" onClick={() => exec("removeFormat")} title="Limpiar formato">Limpiar</button>
            </div>
            <div
                ref={ref}
                className="rte-content prose-lz"
                contentEditable
                onInput={handleInput}
                suppressContentEditableWarning
                data-testid="rich-text-content"
            />
        </div>
    );
}
